module.exports = __webpack_public_path__ + "img/bg_battle_sky.42cee0c8.jpg";